export const state = () => ({
  project: null, // Holds the logged-in project information
});

export const mutations = {
  setProject(state, project) {
    state.project = project;
  },
  getProject(state) {
    return state.project;
  }
};
